import { render, staticRenderFns } from "./DomainRegistrationView.vue?vue&type=template&id=a74f0d08&"
import script from "./DomainRegistrationView.vue?vue&type=script&lang=js&"
export * from "./DomainRegistrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a74f0d08')) {
      api.createRecord('a74f0d08', component.options)
    } else {
      api.reload('a74f0d08', component.options)
    }
    module.hot.accept("./DomainRegistrationView.vue?vue&type=template&id=a74f0d08&", function () {
      api.rerender('a74f0d08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainRegistrationView.vue"
export default component.exports